import { render, staticRenderFns } from "./apprisk.vue?vue&type=template&id=0e2c70d2"
import script from "./apprisk.vue?vue&type=script&lang=js"
export * from "./apprisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports